import React, { memo } from "react";
import { HStack, Text, Highlight } from "@chakra-ui/react";
import colors from "app/colors";
import { getUserMention } from "modules/utils/Functions";
import { InternalAdminUserFragment } from "gql/graphql";
import InternalAdminUserAvatar from "../components/internal-admin-user-avatar";

interface IProps {
  user?: InternalAdminUserFragment;
  search: string;
}

const InternalAdminSelectedUserOption = ({ user, search }: IProps) => {
  if (!user) return null;
  if (user.active) {
    return (
      <HStack color={colors.blue} spacing={1}>
        <InternalAdminUserAvatar
          avatarUrl={user.avatarUrl}
          active={user.active}
          firstName={user.firstName}
          lastName={user.lastName}
          roleType={user.roleType}
          size="2xs"
        />
        <Text noOfLines={1} fontSize={14}>
          <Highlight
            query={search}
            styles={{
              fontWeight: 700,
              color: colors.blue,
              margin: "0 !important",
            }}
          >
            {getUserMention(user)}
          </Highlight>
        </Text>
      </HStack>
    );
  }
  return (
    <HStack color={colors.grayMain} spacing={1}>
      <InternalAdminUserAvatar
        avatarUrl={user.avatarUrl}
        active={user.active}
        firstName={user.firstName}
        lastName={user.lastName}
        roleType={user.roleType}
        size="2xs"
      />
      <Text noOfLines={1} fontSize={14}>
        <Highlight
          query={search}
          styles={{
            fontWeight: 700,
            color: colors.blue,
            margin: "0 !important",
          }}
        >
          {getUserMention(user)}
        </Highlight>
      </Text>
    </HStack>
  );
};

export default memo(InternalAdminSelectedUserOption);
